// src/data/exercises/L2_02.js

const accountOptions = [
  '雑益', '売上', '備品', '現金', '雑収入'];

export const L2_02 = {
  title: '簿記　3級（第218-2回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {

       parts: [
        { type: 'ruby', text: '古新聞', ruby: 'ふるしんぶん' },
        { type: 'text', value: 'などの' },
        { type: 'ruby', text: '不用品', ruby: 'ふようひん' },
        { type: 'text', value: 'の' },
        { type: 'ruby', text: '売却代金', ruby: 'ばいきゃくだいきん' },
        { type: 'text', value: '￥2,000を' },
        { type: 'ruby', text: '現金', ruby: 'げんきん' },
        { type: 'text', value: 'で' },
        { type: 'ruby', text: '受', ruby: 'う' },
        { type: 'text', value: 'け' },
        { type: 'ruby', text: '取', ruby: 'と' },
        { type: 'text', value: 'り、' },
        { type: 'ruby', text: '雑収入', ruby: 'ざつしゅうにゅう' },
        { type: 'text', value: 'として' },
        { type: 'ruby', text: '処理', ruby: 'しょり' },
        { type: 'text', value: 'した。' }
    ]
    
    ,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '現金', debitAmount: 2000, creditAccount: '雑収入', creditAmount: 2000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '現金で受け取り\n' },
          { type: 'text', value: '①現金が増加（プラス）します。\n' },
          { type: 'styled', value: '現金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '雑収入として処理した。\n' },
          { type: 'text', value: '②雑収入の発生です。\n' },
          { type: 'styled', value: '雑収入の発生は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`現金で受け取り
①現金が増加（プラス）します。

雑収入として処理した
②雑収入の発生です。`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '現金で受け取り\n' },
          { type: 'text', value: '①現金が増加（プラス）します。\n' },
          { type: 'styled', value: '現金の増加（プラス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '雑収入として処理した。\n' },
          { type: 'text', value: '②雑収入の発生です。\n' },
          { type: 'styled', value: '雑収入の発生は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};